import type { FormProps } from 'antd';

export const RELATIONSHIP_OPTIONS = [
  { value: 0, label: '' },
  { value: 1, label: '本人' },
  { value: 2, label: '家族' },
  { value: 3, label: '67(本人)' },
];

export const SEX_OPTIONS = [
  { value: 0, label: '' },
  { value: 1, label: '男' },
  { value: 2, label: '女' },
];

export const PATIENT_COST_OPTIONS_KOUKI = [
  { value: 0, label: '初期値' },
  { value: 1, label: '後期高齢１割' },
  { value: 2, label: '後期高齢２割' },
  { value: 3, label: '後期高齢３割' },
];

export const PATIENT_COST_OPTIONS_PUBLIC = [
  { value: 0, label: '初期値' },
  { value: 1, label: '未就学児２割' },
  { value: 2, label: '10割負担' },
  { value: 3, label: '0割負担' },
  { value: 4, label: '前期高齢１割' },
  { value: 5, label: '前期高齢２割' },
  { value: 6, label: '前期高齢３割' },
];

/** insurance_type_id = 2 → 後期高齢 */
export const INSURANCE_TYPE_KOUKI = 2;

/** medical_aid.insurer_type_id = 1 → なし */
export const NO_MEDICAL_AID_ID = 1;

/**
 * Shared Form.Item layout for all certification form sections.
 * `labelAlign: 'left'` keeps labels flush-left in horizontal layout
 * (antd defaults to right-aligned).
 */
export const FORM_ITEM_LAYOUT: Pick<
  FormProps,
  'labelCol' | 'wrapperCol' | 'colon' | 'labelAlign'
> = {
  labelCol: { className: 'w-full pr-0 md:w-[200px] md:pr-2' },
  wrapperCol: { className: 'min-w-0 flex-1' },
  labelAlign: 'left',
  colon: false,
};
